// A jegy-detail SZEKCIÓ-AZONOSÍTÓI — egy helyen, mert a szekciók HÁROM fájlban élnek (route + két komponens),
// és a horgonyoknak stabilnak kell lennie (mélylink, jövőbeli navigáció). A sorrend a lap DOM-sorrendje:
// Leírás → Mellékletek → Fájl-megosztási linkek → Kommentek.
//
// KIESETT horgonyok: `data` (az „Alapadatok" szekciót a fejléc meta-sora váltotta le), `close`
// (a lezárás-ok a fejléc alatt olvasható, a szerkesztése dialógusban) és `manage` (a státusz/felelős/csapat a
// FEJLÉC vezérlői — `TicketInlineControls`, nincs külön „Kezelés" szekció).
export const TICKET_SECTION = {
  description: 'ticket-description',
  attachments: 'ticket-attachments',
  links: 'ticket-links',
  comments: 'ticket-comments',
} as const;
